module.exports = __webpack_public_path__ + "static/media/higienizacao_mamas.98184eef.jpg";